// Dati pre-renderizzati a build time (scripts/prerender.js): validi solo per il percorso corrente.
const norm = (p) => (p || "/").replace(/\/+$/, "") || "/";

export function getPrerender(path) {
  const data = globalThis.__PRERENDER__;
  if (!data) return null;
  if (typeof window !== "undefined" && window.location && norm(window.location.pathname) !== data.path) return null;
  if (path && norm(path) !== data.path) return null;
  return data;
}
